<template>
  <v-card>
    <ODialogBar no-close title="config.yaml">
      <v-btn icon class="ml-2" @click="copyToClipboard">
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
      <v-spacer />
      <v-btn class="ml-2" @click="generateConfig">Gerar</v-btn>
      <v-btn class="ml-2" color="primary" @click="saveConfig">Salvar</v-btn>
    </ODialogBar>

    <v-card-text class="flex-grow-1 px-3 py-0">
      <v-textarea
        v-model="configYaml"
        class="monospace-input dense pa-0"
        auto-grow
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { hasTag } from 'oderon-commons/src/utils'
import { Token, go } from '@/models'

export default {
  props: {
    org: { required: true }
  },
  data() {
    return { configYaml: null }
  },
  watch: {
    org: {
      handler() {
        this.reload()
      },
      immediate: true
    }
  },
  methods: {
    async reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      let projectName = this.org.name
      try {
        let file = await go.get('project-files/' + projectName + '/config.yaml')
        this.configYaml = file.contents
      } catch (err) {
        this.configYaml = ''
      }
    },

    async saveConfig() {
      await this.$loading(async () => {
        await go.post('project-files', {
          projectName: this.org.name,
          filename: 'config.yaml',
          contents: this.configYaml
        })

        this.$snack('Salvo com sucesso')
      })

      this.$emit('reload')
    },

    async generateConfig() {
      let old = this.configYaml
      if (old != null && old.trim().length != 0) {
        let proceed = await this.$confirm({
          title: 'Deseja sobrescrever a config atual?',
          message: 'Ainda é necessário salvar depois desta operação.'
        })

        if (!proceed) return null
      }

      let org = this.org
      let nameWithoutEnv = org.name.replace(/(dev$|hlg$)/, '')

      let isPrd = hasTag(this.org.extraInfo, 'PRD')
      let bucket = isPrd ? 'oderon-rawdata' : 'oderon-test-bucket'

      let { rows } = await Token.findAll({ subject: this.org.name })
      let tokens = rows.map((row) => {
        let appName = row.app.replace(/-dev$/, '')
        return `${appName.padEnd(16)} : ${row.code} @ http://10.0.0.94`
      })

      let faviconStr = ''
      if (!isPrd) faviconStr = 'faviconPrefix    : hlg\n'

      let devSuffix = ''
      if (!isPrd) devSuffix = '-dev'

      let admin = ''
      if (isPrd)
        admin = `admin            : ${org.returnToken} @ http://receiver.prd.odvpc:8091`

      let str = `
orgCode          : ${org.name}
orgLabel         : Oderon ${org.label}
orgUrl           : ${org.url}
${faviconStr}
server           : { port: ${org.extraInfo.internalPort} }
logging          : { console: false }
rawdataStore     : { s3bucket: '${bucket}' }

database         : ${org.database || ''}
redisOpts        : redis.prd.odvpc:6379

${admin}
beeper           : queue:beeper${devSuffix}/beeps
#paperman         : queue:paperman${devSuffix}/history
${tokens.join('\n')}

publicDir        : /oderon/projects/customers/${nameWithoutEnv}/web
      `.trim()

      str = str.replaceAll(/\n{2,}/g, '\n\n')

      this.configYaml = str + '\n'
    },

    copyToClipboard() {
      navigator.clipboard.writeText(this.configYaml)
      this.$snack('Copied to clipboard')
    }
  }
}
</script>

<style></style>
